import { rem, rgba } from 'polished';
import styled from 'styled-components';

import { IBasicUserType } from '../../types';

export const StyledOverlay = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: ${({ theme }) => theme.layers.modal};
  background-color: ${({ theme }) => `${rgba(theme.colors.cross.black, 0.3)}`};
`;

export const StyledPanel = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.main};

  &:focus {
    outline: none; //TODO add proper focus style
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    height: 100%;
  }

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    border-radius: ${({ theme }) => rem(theme.spacings.s)};
    box-shadow: 0 0 ${rem('8px')} 0
      ${({ theme }) => rgba(theme.colors.cross.silverFox, 0.5)};
  }
`;

export const StyledPanelHeaderBar = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${rem('24px')} ${rem('16px')};
  border-bottom: 1px solid ${({ theme }) => theme.colors.cross.lightGray};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    padding: ${rem('24px')};
  }
`;

export const StyledTitle = styled.span`
  color: ${({ theme }) => theme.colors.cross.black};
  font-size: ${rem('24px')};
  font-weight: 700;
`;

export const StyledCloseButton = styled.button`
  display: grid;
  place-items: center;
  width: ${rem('24px')};
  height: ${rem('24px')};
  padding: 0;
  margin-left: auto;
  background: none;
  border: none;
  appearance: none;
  cursor: pointer;

  svg {
    display: block;
    width: ${rem('13px')};
    height: auto;
  }
`;

export const StyledPanelContent = styled.div`
  flex: 1 1 100%;
  overflow: hidden;
`;

export const StyledPanelBottomBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: ${rem('16px')};
  border-top: 1px solid ${({ theme }) => theme.colors.cross.lightGray};

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    padding: ${rem('24px')};
  }
`;

export const StyledCancelButton = styled.button<IBasicUserType>`
  display: inline-flex;
  margin-right: ${rem('24px')};
  padding: 0;
  background-color: transparent;
  border: none;
  color: ${({ theme, user }) =>
    user ? theme.colors[user].main : theme.colors.cross.black};
  font-weight: 700;
  font-size: ${rem('16px')};
  text-decoration: underline;
  cursor: pointer;
  appearance: none;

  &[aria-disabled='true'] {
    color: ${({ theme }) => theme.colors.cross.grayson};
    cursor: default;
    opacity: 0.4;
    pointer-events: none;
  }
`;
